import { debounce } from '@/shared'
import { Salespointgroup, useGetSalespointgroupList } from 'simpleloan_api'
import { ref, computed } from 'vue'

const ALL_IDS_PAGE_SIZE = 100000

export const useModel = ({ pageSize = 15, fields }: { pageSize?: number; fields?: string[] } = {}) => {
  const { post, pending } = useGetSalespointgroupList()
  const allIdsRequest = useGetSalespointgroupList()

  const list = ref<Salespointgroup[]>([])

  const totalSize = ref<number | null>(null)

  const search = ref<string | null>(null)

  const showMore = computed(() =>
    Boolean(list.value.length && totalSize.value && list.value.length < totalSize.value)
  )

  const getFilter = () => ({
    ...(search.value?.trim() && { title: `%${search.value.trim()}%` })
  })

  const onSearch = debounce((str: string | null) => {
    search.value = str
    list.value = []
    totalSize.value = null
    getList()
  }, 500)

  const getList = () => {
    if (pending.value || (totalSize.value && list.value && list.value.length >= totalSize.value)) {
      return
    }

    post({
      search: {
        _filter: getFilter(),
        _start_index: list.value.length,
        _page_size: pageSize,
        _fields: fields
      }
    }).then(res => {
      if (res?._data) {
        totalSize.value = res._data_total_size || null
        list.value.push(...res._data)
      }
    })
  }

  /** id всех групп по текущему поиску, включая ещё не загруженные в список */
  const getAllIds = async (): Promise<number[] | null> => {
    if (!pending.value && !showMore.value) {
      return list.value.map(item => item.id)
    }

    const res = await allIdsRequest.post({
      search: { _filter: getFilter(), _fields: ['id'], _page_size: ALL_IDS_PAGE_SIZE }
    })

    return res?._data?.map(item => item.id) ?? null
  }

  return {
    pending,
    showMore,
    onSearch,
    totalSize,
    list,
    getList,
    getAllIds
  }
}
